module.exports = __webpack_public_path__ + "static/media/Christina_RDA.0c38355d.png";